export default {
  width: 32,
  height: 32,
  svg: `
    <path fill="none" fill-rule="nonzero" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 3a3 3 0 00-3 3v14.212a3 3 0 003 3h5.06l7.78 5.538c1.324.943 3.16-.004 3.16-1.629v-3.909h2a3 3 0 003-3V6a3 3 0 00-3-3H7z"/>
  `,
  stroke: true
}
